export const countries = {
  getCountries: "geo/countries",
};
